import { Token } from 'domain/models';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export type TokenStore = {
	token: Token;
	setToken: (token: Token) => void;
	removeToken: () => void;
};

export const useAuthToken = create<TokenStore>()(
	devtools(
		persist(
			(set) => ({
				token: {} as Token,
				setToken: (token: Token) => set({ token }),
				removeToken: () => set({ token: {} as Token }),
			}),
			{
				name: 'auth-token',
			}
		)
	)
);

export const useRole = (): string[] => {
	const { token } = useAuthToken((state) => state as { token: Token });
	return token.roles ?? [];
};
